import { render } from "./KnowledgePointModal.vue?vue&type=template&id=68af2288"
import script from "./KnowledgePointModal.vue?vue&type=script&lang=js"
export * from "./KnowledgePointModal.vue?vue&type=script&lang=js"
script.render = render

export default script